import i18n from '../i18n';

export const t = <T extends object = { [key: string]: any }>(key: string, args?: T | string) => i18n.t(key, args);
